import { AxiosRequestConfig } from 'axios';
import { APIService } from '../api';
import { mergeConfig } from '../api/utils';
import { Platform } from '../platform/Platform';
import { ApparelSubcategory } from './ApparelSubcategory';
import { Image } from './Image';
import { Model } from './Model';
import { HasMany, Relations, Relationship } from './Relations';

export class ApparelCategory extends Model implements Relations<ApparelCategory> {
    public readonly blueprint = ApparelCategory;
    public readonly endpoint = APIService.createEndpoint('apparel-categories');

    public id: number;
    public name: string;
    public slug: string;
    public code: string;
    public alias: string;
    public group_id: number;
    public image_id: number;
    public image: Image;
    public subcategories: ApparelSubcategory[];

    public relations(): Relationship<{ new (): ApparelCategory }>[] {
        return [HasMany('subcategories', ApparelSubcategory, ApparelCategory)];
    }

    public static async getCategoriesByPlatform(
        platform: string | Platform,
        config?: AxiosRequestConfig,
    ): Promise<ApparelCategory[]> {
        platform = Platform.from(platform)?.toString();

        const { data } = await new ApparelCategory().endpoint.get(
            '',
            mergeConfig(config, {
                params: {
                    platform,
                },
            }),
        );

        return data?.items;
    }

    public urlParam(): string | number {
        return this.slug || this.id;
    }
}
